import { defineStore } from 'pinia';
import { ref } from 'vue';
import { keysApi, type ApiKey, type CreateKeyResponse } from '../api/keys';

export const useKeysStore = defineStore('keys', () => {
  const items = ref<ApiKey[]>([]);
  const loading = ref(false);
  const error = ref<string | null>(null);

  async function load(): Promise<void> {
    loading.value = true;
    error.value = null;
    try {
      const res = await keysApi.list();
      items.value = res.keys;
    } catch (err) {
      error.value = (err as Error).message;
    } finally {
      loading.value = false;
    }
  }

  async function create(name: string | null): Promise<CreateKeyResponse> {
    const res = await keysApi.create(name);
    items.value = [res.key, ...items.value];
    return res;
  }

  async function revoke(id: string): Promise<void> {
    await keysApi.revoke(id);
    const target = items.value.find((k) => k.id === id);
    if (target) target.revoked_at = new Date().toISOString();
  }

  async function setOpenrouter(id: string, enabled: boolean): Promise<void> {
    await keysApi.setOpenrouter(id, enabled);
    const target = items.value.find((k) => k.id === id);
    if (target) target.openrouter_enabled = enabled;
  }

  return { items, loading, error, load, create, revoke, setOpenrouter };
});
